import { render, staticRenderFns } from "./SuppressionActe.vue?vue&type=template&id=44c9ceb4&"
import script from "./SuppressionActe.vue?vue&type=script&lang=js&"
export * from "./SuppressionActe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports